<template>
  <validation-observer ref="observer">
    <v-card>
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-md-caption">{{ startHere }}</p>
        <p class="text-md-caption">{{ notice }}</p>
      </v-col>
    </v-card>
    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <span v-html="section1"></span>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Last Name"
              rules="required"
            >
              <v-text-field
                label="Last name"
                v-model="item.employeeLastName"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="First Name"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeFirstName"
                label="First Name"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Middle Initial"
              rules="required|max:1"
            >
              <v-text-field
                v-model="item.employeeMiddleInitial"
                label="Middle Initial"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.employeeOtherName"
              label="Other Last Names Used (if any)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Address"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeAddress"
                label="Address (Street Number and Name)"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Apt. Number"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeAptNumber"
                label="Apt. Number"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="City/Town"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeCityTown"
                label="City or Town"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="State"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.employeeState"
                    label="State"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Zipcode"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.employeeZipCode"
                    label="Zipcode"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Date of Birth"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeBirthDate"
                label="Date of Birth (mm/dd/yyyy)"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="SSN"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeUsSSN"
                label="U.S. Social Security Number"
                v-mask="mask"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Telephone Number"
              rules="email"
            >
              <v-text-field
                v-model="item.employeeEmail"
                label="Employee's E-mail Address"
                :error-messages="errors"
                readonly
              >
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Telephone Number"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeTelNumber"
                label="Employee's Telephone Number"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <div class="text-md-caption">
          I am aware that federal law provides for imprisonment and/or fines for
          false statements or use of false documents in connection with the
          completion of this form.
        </div>
        <div class="text-md-caption">
          I attest, under penalty of perjury, that I am (check one of the
          following boxes)
        </div>
        <v-row>
          <v-col cols="12" md="12">
            <v-radio-group v-model="item.agreement" row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  v-for="agreement in agreements"
                  :key="agreement"
                >
                  <v-radio
                    :label="agreement"
                    :value="agreement"
                    @change="onChangeAgreement(agreement)"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4" v-if="item.isChkPermanentResident">
            <v-text-field
              v-model="item.alienLawfulRegistrationNumber"
              label="(Alien Registration Number/USCIS Number)"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="item.isChkAlienAuthorizedToWork">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.alienExpirationDate"
              label="Expiration Date, if applicable, mm/dd/yyyy"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="item.documentType"
              :items="document"
              @change="onChangeDocument"
              label="Select Document Type"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" v-if="selectedDocumentTypeIndex === 0">
            <v-text-field
              v-model="item.alienRegistrationNumber"
              label="Alien Registration Number/USCIS Number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" v-if="selectedDocumentTypeIndex === 1">
            <v-text-field
              v-model="item.admissionNumber"
              label="Form I-94 Admission Number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" v-if="selectedDocumentTypeIndex === 2">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="item.foreignPassportNumber"
                  label="Foreign Passport Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="item.issuanceCountry"
                  label="Country of Issuance"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="3" style="position:relative;">
            <v-text-field
              label="Signature of Employee"
              @click="signaturePop()"
              :error-messages="error"
            >
            </v-text-field>
            <v-img
              width="100"
              height="50"
              :src="employeeSignature"
              style="position:absolute;top:10px;right:1px;"
            ></v-img>
            <v-dialog v-model="signaturepop" max-width="50%">
              <v-card>
                <v-card-title>
                  <span class="headline">Signature Pad</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="signaturepop = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <div id="signaturePad">
                  <VueSignaturePad
                    width="400px"
                    height="200px"
                    ref="signaturePad"
                    :options="{
                      onBegin: () => {
                        $refs.signaturePad.resizeCanvas();
                      },
                    }"
                  />
                </div>
                <v-divider></v-divider>
                <v-card-actions class="mr-12">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1 white--text" @click="save"
                    >Save</v-btn
                  >
                  <v-btn @click="undo"> Undo</v-btn>
                  <v-btn @click="clear"> Clear</v-btn>
                  <v-btn color="red darken-1 white--text" @click="cancel"
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.todaysDate"
              label="Today's Date (mm/dd/yyyy"
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="text-md-caption">
          <b>Preparer and/or Translator Certification (check one): </b>
        </div>
        <v-row>
          <v-col cols="12" md="12">
            <v-radio-group
              v-model="item.isChkPreferTranslator"
              row
              @change="onChangePreferTranslator"
            >
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio
                    label="I did not use a preparer or translator. "
                    :value="false"
                  ></v-radio>
                </v-col>
                <v-col cols="12" md="6">
                  <v-radio
                    label="A preparer(s) and/or translator(s) assisted the employee in completing Section 1."
                    :value="true"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
        <div v-if="item.isChkPreferTranslator">
          <div class="text-md-caption">
            (Fields below must be completed and signed when preparers and/or
            translators assist an employee in completing Section 1.
          </div>
          <div class="text-md-caption">
            I attest, under penalty of perjury, that I have assisted in the
            completion of Section 1 of this form and that to the best of my
            knowledge the information is true and correct
          </div>

          <v-row>
            <v-col cols="12" md="3" style="position:relative;">
              <v-text-field
                label="Signature of Preparer or Translator"
                @click="signaturePop2()"
              ></v-text-field>
              <v-img
                width="100"
                height="50"
                :src="translatorSignature"
                style="position:absolute;top:10px;right:1px;"
              ></v-img>
              <v-dialog v-model="signaturepop2" max-width="50%">
                <v-card>
                  <v-card-title>
                    <span class="headline">Signature Pad</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="signaturepop2 = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider></v-divider>
                  <div id="signaturePad2">
                    <VueSignaturePad
                      width="400px"
                      height="200px"
                      ref="signaturePad2"
                      :options="{
                        onBegin: () => {
                          $refs.signaturePad2.resizeCanvas();
                        },
                      }"
                    />
                  </div>
                  <v-divider></v-divider>
                  <v-card-actions class="mr-12">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1 white--text" @click="save2"
                      >Save</v-btn
                    >
                    <v-btn @click="undo"> Undo</v-btn>
                    <v-btn @click="clear"> Clear</v-btn>
                    <v-btn color="red darken-1 white--text" @click="cancel"
                      >Cancel</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="item.todaysDate"
                label="Today's Date (mm/dd/yyyy)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="item.translatorLastName"
                label="Last Name (Family Name)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="item.translatorFirstName"
                label="First Name (Given Name)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="item.translatorAddress"
                label="Address (Street Number and Name)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="item.translatorCityTown"
                label="City or Town"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.translatorState"
                    label="State"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.translatorZipCode"
                    label="ZIP Code"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-card>
    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <div class="text-md-caption">
          <b
            >Section 2. Employer or Authorized Representative Review and
            Verification</b
          >
        </div>
        <div class="text-md-caption">
          (Employers or their authorized representative must complete and sign
          Section 2 within 3 business days of the employee's first day of
          employment. You must physically examine one document from List A OR a
          combination of one document from List B and one document from List C
          as listed on the "Lists of Acceptable Documents."
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.employerLastName"
              label="Last name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.employerFirstName"
              label="First Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.employerMiddleInitial"
              label="Middle Initail"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.employerCitizenshipStatus"
              label="Citizenship/Immigration Status"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-radio-group row @change="onChangeItem" v-model="item.listType">
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio
                    label="List A (Identity and Employment Authorization)"
                    value="lista"
                  ></v-radio>
                </v-col>
                <v-col cols="12" md="6">
                  <v-radio label="List B (Identity)" value="listb"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>

            <div v-if="item.isChkListA">
              <section
                v-for="(identityAndEmploymentAuthorization,
                index) in item.listA"
                :key="identityAndEmploymentAuthorization.id"
                :class="item.listA.length > 1 ? 'list--a' : ''"
              >
                <v-row :class="item.listA.length > 1 ? 'mr-5' : ''">
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Document Title"
                      v-model="identityAndEmploymentAuthorization.documentTitle"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Issuing Authrority"
                      v-model="
                        identityAndEmploymentAuthorization.issuingAuthority
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Document Number"
                      v-model="
                        identityAndEmploymentAuthorization.documentNumber
                      "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Expiration Date (if any)(mm/dd/yyyy"
                      v-model="
                        identityAndEmploymentAuthorization.expirationDate
                      "
                    ></v-text-field>
                  </v-col>
                  <v-fab-transition v-if="item.listA.length > 1">
                    <v-btn
                      color="red"
                      class="mt-11 ml-n16 mx-n5"
                      dark
                      absolute
                      top
                      right
                      fab
                      x-small
                      max-height="23"
                      max-width="24"
                      @click="onRemoveItem(index)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-fab-transition>
                </v-row>
              </section>

              <v-row align="center" justify="end" v-if="item.listA.length != 3">
                <v-card-actions>
                  <v-btn class="btn-add" @click="onAddItem">Add</v-btn>
                </v-card-actions>
              </v-row>
            </div>

            <div v-if="!item.isChkListA && item.listType == 'listb'">
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Document Title"
                    v-model="item.listB.documentTitle"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Issuing Authrority"
                    v-model="item.listB.issuingAuthority"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Document Number"
                    v-model="item.listB.documentNumber"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Expiration Date (if any)(mm/dd/yyyy"
                    v-model="item.listB.expirationDate"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="!item.isChkListA && item.listType == 'listb'">
          <v-col cols="12" md="12">
            <v-radio-group row v-model="item.listTypeC">
              <v-row>
                <v-col cols="12" md="12">
                  <v-radio
                    label="List C (Employment Authorization)"
                    :value="true"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Document Title"
                  v-model="item.listC.documentTitle"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Issuing Authrority"
                  v-model="item.listC.issuingAuthority"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Document Number"
                  v-model="item.listC.documentNumber"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  label="Expiration Date (if any)(mm/dd/yyyy"
                  v-model="item.listC.expirationDate"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <v-textarea
              v-model="item.additionalInformation"
              name="input-7-1"
              label="Additional Information"
              auto-grow
            ></v-textarea>
          </v-col>
        </v-row>
        <div class="text-md-caption">
          <b
            >Certification: I attest, under penalty of perjury, that (1) I have
            examined the document(s) presented by the above-named employee, (2)
            the above-listed document(s) appear to be genuine and to relate to
            the employee named, and (3) to the best of my knowledge the employee
            is authorized to work in the United States.
          </b>
        </div>
        <v-row>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Date"
              rules="required"
            >
              <v-text-field
                v-model="item.employmentDate"
                label="The employee's first day of employment (mm/dd/yyyy)"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" style="position:relative;">
            <v-text-field
              label="Signature of Employer or Authorized Representative"
              @click="signaturePop3()"
              :error-messages="error"
            ></v-text-field>

            <v-img
              width="100"
              height="50"
              :src="authorizedSignature"
              style="position:absolute;top:10px;right:1px;"
            ></v-img>
            <v-dialog v-model="signaturepop3" max-width="50%">
              <v-card>
                <v-card-title>
                  <span class="headline">Signature Pad</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="signaturepop3 = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <div id="signaturePad3">
                  <VueSignaturePad
                    width="400px"
                    height="200px"
                    ref="signaturePad3"
                    :options="{
                      onBegin: () => {
                        $refs.signaturePad3.resizeCanvas();
                      },
                    }"
                  />
                </div>
                <v-divider></v-divider>
                <v-card-actions class="mr-12">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1 white--text" @click="save3"
                    >Save</v-btn
                  >
                  <v-btn @click="undo"> Undo</v-btn>
                  <v-btn @click="clear"> Clear</v-btn>
                  <v-btn color="red darken-1 white--text" @click="cancel"
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="item.todaysDate"
              label="Today's Date(mm/dd/yyyy)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Title"
              rules="required"
            >
              <v-text-field
                v-model="item.authorizedTitle"
                label="Title of Employer or Authorized Representative"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Last Name"
              rules="required"
            >
              <v-text-field
                v-model="item.authorizedLastName"
                label="Last Name of Employer or Authorized Representative"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="First Name"
              rules="required"
            >
              <v-text-field
                v-model="item.authorizedFirstName"
                label="First Name of Employer or Authorized Representative"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Business/Organization"
              rules="required"
            >
              <v-text-field
                v-model="item.authorizedBusiness"
                label="Employer's Business or Organization Name"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="5">
            <validation-provider
              v-slot="{ errors }"
              name="Address"
              rules="required"
            >
              <v-text-field
                v-model="item.authorizedAddress"
                label="Employer's Business or Organization Address (Street Number and Name)"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="City/Town"
              rules="required"
            >
              <v-text-field
                v-model="item.authorizedCityTown"
                label="City or Town"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="State"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.authorizedState"
                    label="State"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Zipcode"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.authorizedZipCode"
                    label="Zipcode"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <div class="text-md-caption">
          <b>Section 3. Reverification and Rehires </b>(To be completed and
          signed by employer or authorized representative.
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="9">
            <div class="text-md-caption">
              <b>A. New Name (if applicable)</b>
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Last Name"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.newLastName"
                    label="Last Name (Family Name)"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="First Name"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.newFirstName"
                    label="First Name (Given Name)"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Middle Initial"
                  rules="required|max:1"
                >
                  <v-text-field
                    v-model="item.newMiddleInitial"
                    label="Middle Initial"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <div class="text-md-caption">
              <b>B. Date of Rehire (if applicable) </b>
            </div>
            <v-row>
              <v-col cols="12" md="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="Date"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.rehireDate"
                    label="Date (mm/dd/yyyy)"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <div class="text-md-caption">
              <b
                >C. If the employee's previous grant of employment authorization
                has expired, provide the information for the document or receipt
                that establishes continuing employment authorization in the
                space provided below.</b
              >
            </div>
            <v-row>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Document Title"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.documentTitle"
                    label="Document Title"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Document Number"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.documentNumber"
                    label="Document Number"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="4">
                <validation-provider
                  v-slot="{ errors }"
                  name="Expiration Date"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.expirationDate"
                    label="Expiration Date (if any) (mm/dd/yyyy)"
                    :error-messages="errors"
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <div class="text-md-caption">
              <b
                >I attest, under penalty of perjury, that to the best of my
                knowledge, this employee is authorized to work in the United
                States, and if the employee presented document(s), the
                document(s) I have examined appear to be genuine and to relate
                to the individual.</b
              >
            </div>
            <v-row>
              <v-col cols="12" md="4" style="position:relative;">
                <v-text-field
                  label="Signature of Employer or Authorized Representative"
                ></v-text-field>
                <v-img
                  width="100"
                  height="50"
                  :src="authorizedSignature"
                  style="position:absolute;top:10px;right:1px;"
                ></v-img>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.todaysDate"
                  label="Today's Date (mm/dd/yyyy)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.authorizedName"
                  label="Name of Employer or Authorized Representative"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-row align="center" justify="start">
                  <v-card-actions>
                    <v-btn @click="prev">Prev</v-btn>
                  </v-card-actions>
                </v-row>
              </v-col>

              <v-col>
                <v-row align="center" justify="end">
                  <v-card-actions>
                    <v-btn @click="next">Next</v-btn>
                  </v-card-actions>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </validation-observer>
</template>
<script>
/* eslint-disable */
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import download from "downloadjs";

export default {
  components: { ValidationProvider, ValidationObserver },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      startHere:
        "START HERE: Read instructions carefully before completing this form. The instructions must be available, either in paper or electronically, during completion of this form. Employers are liable for errors in the completion of this form",
      notice:
        "ANTI-DISCRIMINATION NOTICE: It is illegal to discriminate against work-authorized individuals. Employers CANNOT specify which  document(s) an employee may present to establish employment authorization and identity. The refusal to hire or continue to employ  an individual because the documentation presented has a future expiration date may also constitute illegal discrimination",
      section1:
        "<b> Section 1. Employee Information and Attestation </b>(Employees must complete and sign Section 1 of Form I-9 no later  than the first day of employment, but not before accepting a job offer.",
      e1: 1,
      userID: localStorage.getItem("userID"),
      todaysDate: moment(new Date()).format("MM-DD-YYYY"),
      selectedDocumentTypeIndex: null,
      document: [
        "Alien Registration Number/USCIS Number",
        "Form I-94 Admission Number",
        "Foreign Passport Number",
      ],
      agreementIndex: null,
      agreements: [
        "A citizen of the United States",
        "A noncitizen national of the United States (See instructions)",
        "A lawful permanent resident",
        'An alien authorized to work until (expiration date, if applicable, mm/dd/yyyy):  Some aliens may write "N/A" in the expiration date field. (See instructions)',
      ],
      employeeSignature: "",
      signaturepop: false,
      signaturepop2: false,
      signaturepop3: false,
      mask: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
      error: "",
      steps: this.currentStep,
      item: {
        agreement: null,
        isChkCitizen: false,
        isChkNonCitizen: false,
        isChkPermanentResident: false,
        isChkAlienAuthorizedToWork: false,
        isChkListA: false,
        listA: [{}],
        listB: {},
        listC: {},
      },
      translatorSignature: null,
      authorizedSignature: "",
    };
  },

  created() {
    this.populateUserInfo();
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),

    onChangeAgreement(e) {
      for (let i = 0; i < this.agreements.length; i++) {
        const agreement = this.agreements[i];

        if (i === 0 && agreement === e) {
          this.agreementIndex = i;
          this.item.isChkCitizen = true;
          this.item.isChkNonCitizen = false;
          this.item.isChkPermanentResident = false;
          this.item.isChkAlienAuthorizedToWork = false;
          this.item.agreement = agreement;
          this.item.alienLawfulRegistrationNumber = "";
          this.item.alienExpirationDate = "";
          this.item.documentType = "";
          this.item.alienRegistrationNumber = "";
          this.item.admissionNumber = "";
          this.item.foreignPassportNumber = "";
          this.item.issuanceCountry = "";
          return;
        }

        if (i === 1 && agreement === e) {
          this.agreementIndex = i;
          this.item.agreement = agreement;
          this.item.isChkCitizen = false;
          this.item.isChkNonCitizen = true;
          this.item.isChkPermanentResident = false;
          this.item.isChkAlienAuthorizedToWork = false;
          this.item.alienLawfulRegistrationNumber = "";
          this.item.alienExpirationDate = "";
          this.item.documentType = "";
          this.item.alienRegistrationNumber = "";
          this.item.admissionNumber = "";
          this.item.foreignPassportNumber = "";
          this.item.issuanceCountry = "";
          return;
        }

        if (i === 2 && agreement === e) {
          this.agreementIndex = i;
          this.item.agreement = agreement;
          this.item.isChkCitizen = false;
          this.item.isChkNonCitizen = false;
          this.item.isChkPermanentResident = true;
          this.item.isChkAlienAuthorizedToWork = false;
          this.item.alienExpirationDate = "";
          this.item.documentType = "";
          this.item.alienRegistrationNumber = "";
          this.item.admissionNumber = "";
          this.item.foreignPassportNumber = "";
          this.item.issuanceCountry = "";
          return;
        }

        if (i === 3 && agreement === e) {
          this.agreementIndex = i;
          this.item.agreement = agreement;
          this.item.isChkCitizen = false;
          this.item.isChkNonCitizen = false;
          this.item.isChkPermanentResident = false;
          this.item.isChkAlienAuthorizedToWork = true;
          this.item.alienLawfulRegistrationNumber = "";
          return;
        }

        this.item.isChkCitizen = false;
        this.item.isChkNonCitizen = false;
        this.item.isChkPermanentResident = false;
        this.item.isChkAlienAuthorizedToWork = false;
      }
    },

    onChangeDocument(e) {
      this.selectedDocumentTypeIndex = this.documentType.findIndex(
        (index) => index === e
      );
    },

    onChangePreferTranslator(e) {
      if (!e) {
        this.item.translatorLastName = "";
        this.item.translatorFirstName = "";
        this.item.translatorAddress = "";
        this.item.translatorCityTown = "";
        this.item.translatorState = "";
        this.item.translatorZipCode = "";
      }
      this.item.isChkPreferTranslator = e;
    },

    onChangeItem(e) {
      if (e == "lista") {
        this.item.isChkListA = true;
        this.item.listTypeC = false;
        this.item.listB = {};
        this.item.listC = {};
        return;
      }

      if (e == "listb" || this.item.listTypeC) {
        this.item.isChkListA = false;
        this.item.listTypeC = true;
        this.item.listA = [{}];
      }
      this.item.isChkListA = false;
    },

    onAddItem() {
      this.item.listA.push({});
    },

    onRemoveItem(index) {
      this.item.listA.splice(index, 1);
    },

    signaturePop() {
      this.signaturepop = true;
      this.error = "";
      if (this.$refs.signaturePad !== undefined) {
        this.$refs.signaturePad.clearSignature();
      }
    },
    save() {
      const { data } = this.$refs.signaturePad.saveSignature();
      this.employeeSignature = data;
      this.signaturepop = false;
    },
    signaturePop2() {
      this.signaturepop2 = true;
      if (this.$refs.signaturePad2 !== undefined) {
        this.$refs.signaturePad2.clearSignature();
      }
    },
    save2() {
      const { data } = this.$refs.signaturePad2.saveSignature();
      this.translatorSignature = data;
      this.signaturepop2 = false;
    },
    signaturePop3() {
      this.signaturepop3 = true;
      this.error = "";
      if (this.$refs.signaturePad3 !== undefined) {
        this.$refs.signaturePad3.clearSignature();
      }
    },
    save3() {
      const { data } = this.$refs.signaturePad3.saveSignature();
      this.authorizedSignature = data;
      this.signaturepop3 = false;
    },
    undo() {
      if (this.$refs.signaturePad !== undefined) {
        this.$refs.signaturePad.undoSignature();
      }
      if (this.$refs.signaturePad2 !== undefined) {
        this.$refs.signaturePad2.undoSignature();
      }
      if (this.$refs.signaturePad3 !== undefined) {
        this.$refs.signaturePad3.undoSignature();
      }
      if (this.$refs.signaturePad4 !== undefined) {
        this.$refs.signaturePad4.undoSignature();
      }
      if (this.$refs.signaturePad5 !== undefined) {
        this.$refs.signaturePad5.undoSignature();
      }
    },
    clear() {
      if (this.$refs.signaturePad !== undefined) {
        this.$refs.signaturePad.clearSignature();
      }
      if (this.$refs.signaturePad2 !== undefined) {
        this.$refs.signaturePad2.clearSignature();
      }
      if (this.$refs.signaturePad3 !== undefined) {
        this.$refs.signaturePad3.clearSignature();
      }
      if (this.$refs.signaturePad4 !== undefined) {
        this.$refs.signaturePad4.clearSignature();
      }
      if (this.$refs.signaturePad5 !== undefined) {
        this.$refs.signaturePad5.clearSignature();
      }
    },
    cancel() {
      this.signaturepop = false;
      this.signaturepop2 = false;
      this.signaturepop3 = false;
    },

    async next() {
      console.log(this.item);
      this.addItem();
      // this.$emit("clicked", this.steps + 1);
    },

    prev() {
      this.$emit("clicked", this.step - 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: this.item,
          pdfDocument: "employment-eligibility",
          employeeID: this.user._id,
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      const { Address, City, State, Zip, Email } = this.user;

      this.item.employeeAddress = Address;
      this.item.employeeCityTown = City;
      this.item.employeeState = State;
      this.item.employeeZipCode = Zip;
      this.item.employeeEmail = Email;

      const response = await this.getDocuments(this.user._id);

      if (response.data.document.Documents.EmploymentEligibility != undefined) {
        console.log("employment");
        let documents = this.updateCase(
          response.data.document.Documents.EmploymentEligibility
        );

        this.item = Object.assign(
          {},
          {
            ...documents,
            listA: documents.listA.length > 0 ? documents.listA : [{}],
            listB: documents?.listB ? documents.documents.listB : {},
            listC: documents.listC?.length ? documents.documents.listC : {},
          }
        );
      }
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "employment-application",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(pdfFile, "employment-application.pdf", "application/pdf");
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.list--a {
  position: relative;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
